import { AxiosError } from "axios"
import { useCallback } from "react"
import { useAppDispatch } from "reducers/store"
import { showToast } from "reducers/toast/toast-actions"

interface IApiErrorMessage {
  clientErrorMessage: string
}

function useHandleApiError() {
  const appDispatch = useAppDispatch()

  const getErrorMessage = useCallback((error: unknown, defaultMessage: string) => {
    const axiosError = error as AxiosError<IApiErrorMessage>

    const apiErrorMessage = axiosError.response?.data?.clientErrorMessage

    return apiErrorMessage || defaultMessage
  }, [])

  const getErrorMessageAndShowErrorToast = useCallback(
    (error: unknown, defaultMessage: string) => {
      const toastErrorMessage = getErrorMessage(error, defaultMessage)

      appDispatch(showToast(toastErrorMessage, "error"))

      return toastErrorMessage
    },
    [appDispatch, getErrorMessage]
  )

  return {
    getErrorMessage,
    getErrorMessageAndShowErrorToast
  }
}

export default useHandleApiError
